// extracted by css-extract-rspack-plugin
export default {"root":"root-dzzDzo","header":"header-nM0Zjb","side":"side-Rjb2PP","main":"main-FybDsM"};